/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsMobileIndexHeader = {
  init() {
    $('#template-index').css({
      'margin-top': -1 * Math.ceil($('#mobile-header-sticky-wrapper').height() + 2)
    })
  },

  unload() {
    $('#template-index').css({
      'margin-top': '' 
    })
  },
};
/******/ })()
;